<template>
  <tr>
    <td style="width:2em;">
      <v-icon v-if="item.rank <= 3" :color="trophyColor">mdi-trophy</v-icon>
    </td>
    <td style="width:2em;">
      {{ item.rank }}
    </td>
    <td>
      <User :user-obj="user" />
    </td>
    <td>
      <router-link
        v-if="user"
        :to="`/user/${user.name}/code/${item.codeId}`"
      >
        {{ item.score }}
      </router-link>
    </td>
  </tr>
</template>

<script>
import {db} from "@/firebase/db.js"
import User from '@/components/User.vue'

export default {
  components: {
    User,
  },
  props: ['item'], 
  data: () => ({
    user: null,
  }),
  computed: {
    trophyColor: function () {
      const colors = ["yellow darken-2", "blue-grey lighten-2", "brown lighten-1"]
      return !this.item || this.item.rank > 3 ? "" : colors[this.item.rank-1]
    },
  },
  methods: {
    bind: function () {
      this.$bind("user", db.collection("users").doc(this.item.user))
    },
  },
  watch: {
    item: function () {
      this.bind()
    },
  },
  created() {
    this.bind()
  },
}
</script>




